module.exports = __webpack_public_path__ + "static/media/I3.42f93041.png";